import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { Provider } from "starfx/react";

import { licenseKey } from "./devextreme-license";

import { DispatchProvider } from "./statefx/hook";
import { runFxState } from "./statefx/xstore";
import { schema } from "./statefx/schema";
import { Store } from "./state/rootState";
import { AppFusion, ReverseRoute } from "./contexts";

import App from "./App";

import config from "devextreme/core/config";
import themes from "devextreme/ui/themes";

import "./i18n";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "./service-worker";
import "./index.css";
config({ licenseKey });

const fxStore = runFxState();
window.fx = fxStore;
themes.initialized(() => {
  // console.log("themes initialized");
  void 0;
});
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const RootMode =
  process.env.NODE_ENV === "development" ? React.Fragment : StrictMode;

root.render(
  <RootMode>
    <HashRouter>
      <Provider store={fxStore} schema={schema}>
        <DispatchProvider store={fxStore}>
          <Store>
            <AppFusion>
              <ReverseRoute>
                <App />
              </ReverseRoute>
            </AppFusion>
          </Store>
        </DispatchProvider>
      </Provider>
    </HashRouter>
  </RootMode>
);
